import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import axios from "axios";
import { Cookies } from "react-cookie";
const cookies = new Cookies();

const COMPANY_BRANDS = [
  "MOREVER",
  "PETER&JOHN",
  "MANUKA SCIENCE",
  "REDWOODS",
  "JYP",
  "NEWZEAL",
  "VENUSTAS",
  "BORN HEALTHY",
];

const CompanyForm = ({
  fetchCompanies,
  selectedCompany,
  setSelectedCompany,
  setShow,
  brands,
}) => {
  const [companyName, setCompanyName] = useState("");
  const [wholesaler, setWholesaler] = useState("");
  const [managerName, setManagerName] = useState("");
  const [managerTel, setManagerTel] = useState("");
  const [managerEmail, setManagerEmail] = useState("");
  const [grade, setGrade] = useState("");
  const [memo, setMemo] = useState("");
  const [allowAllBrand, setAllowAllBrand] = useState(false);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [isCompanyBrand, setIsCompanyBrand] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (selectedCompany) {
      console.log("brands ", brands);
      console.log("selected Company ", selectedCompany);

      setCompanyName(selectedCompany.company_name);
      setWholesaler(selectedCompany.wholesaler);
      setManagerName(
        selectedCompany.manager_name !== null
          ? selectedCompany.manager_name
          : ""
      );
      setManagerTel(
        selectedCompany.manager_tel !== null ? selectedCompany.manager_tel : ""
      );
      setManagerEmail(selectedCompany.manager_email);
      setGrade(selectedCompany.purchase_grade);
      setMemo(
        selectedCompany.company_memo !== null
          ? selectedCompany.company_memo
          : ""
      );
      setAllowAllBrand(selectedCompany.allow_all_brand || false);
      setSelectedBrands(selectedCompany.brand_list || []);
    } else {
      setCompanyName("");
      setWholesaler("");
      setManagerName("");
      setManagerTel("");
      setManagerEmail("");
      setGrade("");
      setMemo("");
      setAllowAllBrand(false);
      setSelectedBrands([]);
    }
  }, [selectedCompany]);

  useEffect(() => {
    console.log(selectedBrands);
  }, [selectedBrands]);

  const handleBrandChange = (brandId) => {
    setSelectedBrands((prev) => {
      if (prev.includes(brandId)) {
        return prev.filter((id) => id !== brandId);
      } else {
        return [...prev, brandId];
      }
    });
  };

  const handleCompanyBrandChange = (e) => {
    const isChecked = e.target.checked;
    setIsCompanyBrand(isChecked);

    if (isChecked) {
      // Add company brands if they're not already selected
      const companyBrandIds = brands
        .filter((brand) => COMPANY_BRANDS.includes(brand.brand_name))
        .map((brand) => brand.brand_index);

      setSelectedBrands((prev) => {
        const newSelected = [...prev];
        companyBrandIds.forEach((id) => {
          if (!newSelected.includes(id)) {
            newSelected.push(id);
          }
        });
        return newSelected;
      });
    } else {
      // Remove company brands
      const companyBrandIds = brands
        .filter((brand) => COMPANY_BRANDS.includes(brand.brand_name))
        .map((brand) => brand.brand_index);

      setSelectedBrands((prev) =>
        prev.filter((id) => !companyBrandIds.includes(id))
      );
    }
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      // Select all brands
      const allBrandIds = brands.map((brand) => brand.brand_index);
      setSelectedBrands(allBrandIds);
    } else {
      // Deselect all brands
      setSelectedBrands([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (selectedCompany) {
        await axios.put(
          `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/company/${selectedCompany.company_index}`,
          {
            companyName,
            wholesaler,
            managerName,
            managerTel,
            managerEmail,
            grade,
            memo,
            allowAllBrand,
            allowedBrands: allowAllBrand ? [] : selectedBrands,
          },
          {
            headers: {
              Authorization: cookies.get("info").token,
            },
          }
        );
      } else {
        await axios.post(
          `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/company`,
          {
            companyName,
            wholesaler,
            managerName,
            managerTel,
            managerEmail,
            grade,
            memo,
            allowAllBrand,
            allowedBrands: allowAllBrand ? [] : selectedBrands,
          },
          {
            headers: {
              Authorization: cookies.get("info").token,
            },
          }
        );
      }
      fetchCompanies();
      setCompanyName("");
      setWholesaler("");
      setManagerName("");
      setManagerTel("");
      setManagerEmail("");
      setGrade("");
      setMemo("");
      setAllowAllBrand(false);
      setSelectedBrands([]);
      setSelectedCompany(null);
      setShow(false);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Container>
      <Row>
        <Col md={{ size: 8, offset: 2 }}>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="companyName">회사 이름(사업자등록증 기준)</Label>
                  <Input
                    type="text"
                    name="companyName"
                    id="companyName"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="wholesaler">업체명(주문서 작성용)</Label>
                  <Input
                    type="text"
                    name="wholesaler"
                    id="wholesaler"
                    value={wholesaler}
                    onChange={(e) => setWholesaler(e.target.value)}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="managerName">담당자명</Label>
                  <Input
                    type="text"
                    name="managerName"
                    id="managerName"
                    value={managerName}
                    onChange={(e) => setManagerName(e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="managerTel">전화번호</Label>
                  <Input
                    type="text"
                    name="managerTel"
                    id="managerTel"
                    value={managerTel}
                    onChange={(e) => setManagerTel(e.target.value)}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="managerEmail">이메일</Label>
                  <Input
                    type="managerEmail"
                    name="managerEmail"
                    id="managerEmail"
                    value={managerEmail}
                    onChange={(e) => setManagerEmail(e.target.value)}
                    required
                  />
                </FormGroup>{" "}
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="grade">그룹</Label>
                  <Input
                    type="select"
                    name="grade"
                    id="grade"
                    value={grade}
                    onChange={(e) => setGrade(e.target.value)}
                    required
                  >
                    <option value="">선택...</option>
                    <option value="korg">KORG</option>
                    <option value="kor">KOR</option>
                    <option value="locaa">LOCAA</option>
                    <option value="loca">LOCA</option>
                    <option value="ventus">VENTUS</option>
                    <option value="vip">VIP</option>
                    <option value="online">ONLINE</option>
                  </Input>
                </FormGroup>{" "}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="allowAllBrand">브랜드 노출 설정</Label>
                  <Input
                    type="select"
                    name="allowAllBrand"
                    id="allowAllBrand"
                    value={allowAllBrand}
                    onChange={(e) =>
                      setAllowAllBrand(e.target.value === "true")
                    }
                  >
                    <option value="true">전체노출</option>
                    <option value="false">노출제한</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="memo">메모</Label>
                  <Input
                    type="memo"
                    name="memo"
                    id="memo"
                    value={memo}
                    onChange={(e) => setMemo(e.target.value)}
                  />
                </FormGroup>
              </Col>
            </Row>
            {!allowAllBrand && (
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>노출 허용 브랜드</Label>
                    <div className="mb-3 d-flex gap-3">
                      <div className="form-check">
                        <Input
                          type="checkbox"
                          id="companyBrand"
                          checked={isCompanyBrand}
                          onChange={handleCompanyBrandChange}
                          className="form-check-input"
                        />
                        <Label
                          className="form-check-label ms-2"
                          for="companyBrand"
                        >
                          자사브랜드
                        </Label>
                      </div>
                      <div className="form-check">
                        <Input
                          type="checkbox"
                          id="selectAll"
                          checked={selectAll}
                          onChange={handleSelectAllChange}
                          className="form-check-input"
                        />
                        <Label
                          className="form-check-label ms-2"
                          for="selectAll"
                        >
                          전체선택
                        </Label>
                      </div>
                    </div>
                    <Row>
                      <Col md={6}>
                        <div
                          className="border p-3 rounded"
                          style={{
                            maxHeight: "300px",
                            overflowY: "auto",
                            backgroundColor: "#f8f9fa",
                          }}
                        >
                          {brands.length > 0 ? (
                            <div className="d-flex flex-column">
                              {brands.map((brand) => (
                                <div
                                  key={brand.brand_index}
                                  className="mb-1 p-1 border rounded"
                                  style={{
                                    backgroundColor: selectedBrands.includes(
                                      brand.brand_index
                                    )
                                      ? "#e3f2fd"
                                      : "white",
                                  }}
                                >
                                  <div className="form-check">
                                    <Input
                                      type="checkbox"
                                      id={`brand-${brand.brand_index}`}
                                      checked={selectedBrands.includes(
                                        brand.brand_index
                                      )}
                                      onChange={() =>
                                        handleBrandChange(brand.brand_index)
                                      }
                                      className="form-check-input"
                                    />
                                    <Label
                                      className="form-check-label ms-2"
                                      for={`brand-${brand.brand_index}`}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {brand.brand_name}
                                    </Label>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="text-center text-muted">
                              브랜드 목록을 불러오는 중입니다...
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col md={6}>
                        <div
                          className="border p-3 rounded"
                          style={{
                            maxHeight: "300px",
                            overflowY: "auto",
                            backgroundColor: "#f8f9fa",
                          }}
                        >
                          <h6 className="mb-3">선택된 브랜드</h6>
                          {selectedBrands.length > 0 ? (
                            <div className="d-flex flex-column">
                              {brands
                                .filter((brand) =>
                                  selectedBrands.includes(brand.brand_index)
                                )
                                .map((brand) => (
                                  <div
                                    key={brand.brand_index}
                                    className="mb-1 p-2 border rounded d-flex justify-content-between align-items-center"
                                    style={{ backgroundColor: "#e3f2fd" }}
                                  >
                                    <span>{brand.brand_name}</span>
                                    <button
                                      type="button"
                                      className="btn btn-link p-0 text-danger"
                                      onClick={() =>
                                        handleBrandChange(brand.brand_index)
                                      }
                                      style={{ textDecoration: "none" }}
                                    >
                                      ✕
                                    </button>
                                  </div>
                                ))}
                            </div>
                          ) : (
                            <div className="text-center text-muted">
                              선택된 브랜드가 없습니다
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
              </Row>
            )}
            <Button type="submit" color="primary">
              도매업체 {selectedCompany ? "정보 수정" : "추가"}
            </Button>{" "}
            <Button color="secondary" onClick={() => setShow(false)}>
              취소
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default CompanyForm;
